import * as React from 'react';
import { FC } from 'react';
import CreditCardSelectField from './CreditCardSelectField';
import RowTarget from './RowTarget';
import { useContext } from './useFormContext';
import { UpdateValidationState } from './useValidationState';

const PrependFields: FC<{
  updateValidationState: UpdateValidationState;
}> = ({ updateValidationState }) => {
  const context = useContext();

  switch (context.key) {
    case 'card_withdrawal':
      return <CreditCardSelectField />;
    case 'user_withdrawal':
      return <RowTarget updateValidationState={updateValidationState} validation="required" />;
    default:
      return null;
  }
};

export default PrependFields;
